import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { AnimatePresence, motion } from 'framer-motion'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  const navItems = [
    { name: 'Historia', path: '/history' },
    { name: 'Comunidad', path: '/community' },
    { name: 'Golf', path: '/golf' },
    { name: 'Blog', path: '/blog' },
    { name: 'Acerca de', path: '/about' },
  ]

  const isActive = (path) => location.pathname === path

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    setIsOpen(false)
  }, [location.pathname])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <>
      <a href="#contenido" className="skip-link">
        Saltar al contenido
      </a>
      <nav
        className={`sticky top-0 z-50 border-b bg-ivory/90 text-ink backdrop-blur-md transition-shadow ${
          scrolled ? 'border-leaf/15 shadow-sm' : 'border-transparent'
        }`}
      >
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-3" aria-label="Inicio, Golf Adaptado">
            <img src="/golf-icon.svg" alt="" className="h-9 w-9" />
            <span className="flex flex-col leading-none">
              <span className="font-serif text-lg font-semibold text-leaf">
                Golf Adaptado
              </span>
              <span className="mt-1 text-[11px] tracking-wide text-mist">
                Asociación Nacional
              </span>
            </span>
          </Link>

          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-leaf text-white'
                    : 'text-mist hover:bg-cream hover:text-leaf'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact" className="btn-primary ml-3">
              Únete
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setIsOpen((open) => !open)}
            className="rounded-full p-2.5 text-ink hover:bg-cream lg:hidden"
            aria-expanded={isOpen}
            aria-controls="menu-movil"
            aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            id="menu-movil"
            className="fixed inset-0 z-40 bg-fairway-deep px-6 pb-10 pt-24 text-cream lg:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <nav className="flex h-full flex-col justify-between">
              <ul className="space-y-1">
                <li>
                  <Link
                    to="/"
                    className={`block px-2 py-3 font-serif text-3xl ${
                      isActive('/') ? 'text-sun' : 'text-cream'
                    }`}
                  >
                    Inicio
                  </Link>
                </li>
                {navItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`block px-2 py-3 font-serif text-3xl ${
                        isActive(item.path) ? 'text-sun' : 'text-cream'
                      }`}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn-brass w-full py-4 text-base">
                Únete a la comunidad
              </Link>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Navbar
